import { QueryClient as V4QueryClient } from '@tanstack/react-query';
import type { DefaultOptions as V4DefaultOptions } from '@tanstack/react-query';
import type { DefaultOptions } from 'react-query';
import { QueryClient } from 'react-query';

import { ApiClient } from './api';
import { isInstanceOfIErrorPayload } from './types';

const defaultOptions: DefaultOptions = {
  queries: {
    queryFn({ queryKey }) {
      const [endpoint, options] = queryKey;
      // `useDjangoPaginatedQuery` embeds the `searchParams` as part of `options`
      // If defined, use `searchParams` otherwise use `options`.
      const { searchParams } = (options ?? {}) as never;
      return ApiClient.get(endpoint as string, {
        params: searchParams ?? options,
      });
    },
    retry(failureCount: number, error: unknown) {
      return isInstanceOfIErrorPayload(error) && error.status === 500 && failureCount < 3;
    },
    refetchOnWindowFocus: false,
  },
};

const v4DefaultOptions: V4DefaultOptions = {
  queries: {
    queryFn({ queryKey }) {
      const [endpoint, options] = queryKey;
      // `useDjangoPaginatedQuery` embeds the `searchParams` as part of `options`
      // If defined, use `searchParams` otherwise use `options`.
      const { searchParams } = (options ?? {}) as never;
      return ApiClient.get(endpoint as string, {
        params: searchParams ?? options,
      });
    },
    retry(failureCount: number, error: unknown) {
      return isInstanceOfIErrorPayload(error) && error.status === 500 && failureCount < 3;
    },
    refetchOnWindowFocus: false,
  },
};

export const reactQueryClient: QueryClient = new QueryClient({
  defaultOptions,
});

export const v4ReactQueryClient: V4QueryClient = new V4QueryClient({
  defaultOptions: { ...v4DefaultOptions },
});
